import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useBreakpoints } from "react-device-breakpoints";
import { BsViewList } from "react-icons/bs";
import { FaBars, FaHome, FaUserMd } from "react-icons/fa";
import { FiSun, FiUserPlus } from "react-icons/fi";
import { HiSearch } from "react-icons/hi";
import { MdDarkMode } from "react-icons/md";
import { RiArrowLeftSLine } from "react-icons/ri";
import { TiContacts } from "react-icons/ti";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import avatar from "../../assets/img/avatar.png";
import logoWhite from "../../assets/img/logo-white.png";
import logo from "../../assets/img/logo.png";
import { GET_LOCALSTORAGE_JWT } from "../../config";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { themeAction } from "../../store/actions/themeActions";
import SearchPanel from "../searchPanel";
const Header = () => {
  const [menuShow, setMenuShow] = useState(false);
  const [showSearch, setShowSearchBar] = useState(false);
  const navigate = useNavigate();
  const handleLogout = () => {
    Cookies.remove("jwt_token");
    localStorage.removeItem("jwt_token");
    navigate("/login");
  };
  useEffect(() => {
    GET_LOCALSTORAGE_JWT("jwt_token");
  }, []);
  // devie breakpoints
  const device = useBreakpoints();
  useEffect(() => {
    if (!device.isSemiPortraitTablet || !device.isDesktop) {
      setShowSearchBar(false);
      setMenuShow(false);
    }
  }, [device.isSemiPortraitTablet, device.isDesktop]);
  if (showSearch) {
    document.getElementById("search_field").focus();
  }

  const dispatch = useDispatch();

  const [value, setValue] = useLocalStorage("theme", "light");
  const handleThemeMode = () => {
    if (value === "dark") {
      setValue("light");
      dispatch(themeAction("light"))
    } else {
      setValue("dark");
      dispatch(themeAction("dark"))
    }
  };

  useEffect(() => {
    if (value === "dark") {
      document.body.classList.add("dark");
      document.body.classList.remove("light");
    } else {
      document.body.classList.remove("dark");
      document.body.classList.add("light");
    }
  }, [value]);
  return (
    <header>
      <div className="container">
        <div className="navbar">
          <div className="logo">
            <h2>
              <Link to="/">
                <img
                  src={value === "dark" ? logo : logoWhite}
                  width="100%"
                  alt="logo"
                />
              </Link>
            </h2>
          </div>
          <div
            className={`search_bar ${showSearch ? "active_search_bar" : ""}`}
          >
            {device.isSemiPortraitTablet && showSearch && (
              <RiArrowLeftSLine
                className="search_bar_back"
                onClick={() => setShowSearchBar(false)}
              />
            )}{" "}
            <SearchPanel />
          </div>
          {device.isSemiPortraitTablet && (
            <HiSearch
              className="search_icon"
              onClick={() => setShowSearchBar(true)}
            />
          )}
          {device.isDesktop && (
            <div className="toggler_icon">
              <FaBars onClick={() => setMenuShow(!menuShow)} />
            </div>
          )}

          <div className={`menu ${menuShow ? "active_menu" : ""}`}>
            <ul>
              {device.isSemiPortraitTablet && (
                <li
                  style={{
                    textAlign: "end",
                  }}
                >
                  <Link
                    to="#"
                    onClick={() => setMenuShow(false)}
                    className="text-danger"
                  >
                    Close
                  </Link>
                </li>
              )}

              <li>
                <Link to="/">
                  {" "}
                  <span>
                    <FaHome style={{ marginBottom: "-1px" }} />
                  </span>{" "}
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/list-my-plan">
                  {" "}
                  <span>
                    <BsViewList style={{ marginBottom: "-1px" }} />
                  </span>{" "}
                  List My Plan
                </Link>
              </li>
              <li>
                <Link to="/about">
                  {" "}
                  <span>
                    <TiContacts style={{ marginBottom: "-1px" }} />
                  </span>{" "}
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact">
                  {" "}
                  <span>
                    <TiContacts style={{ marginBottom: "-1px" }} />
                  </span>{" "}
                  Contact Us
                </Link>
              </li>
              {!GET_LOCALSTORAGE_JWT("jwt_token") ? (
                <>
                  <li>
                    <Link to="/login">
                      <span>
                        <FaUserMd style={{ marginBottom: "-1px" }} />
                      </span>{" "}
                      Login
                    </Link>
                  </li>
                  <li>
                    <Link to="/register">
                      <span>
                        <FiUserPlus style={{ marginBottom: "-1px" }} />
                      </span>{" "}
                      Register
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li className="avatar_menu">
                    <img
                      src={avatar}
                      width="100%"
                      alt="avatar"
                      className="img-fluid"
                    />
                    <ul className="dropdown_menu">
                      <li>
                        <Link to="/user/viewprofile">View Profile</Link>
                      </li>
                      <li onClick={handleLogout}>
                        <Link to="#">Logout</Link>
                      </li>
                    </ul>
                  </li>
                </>
              )}
              <li className="dark_switch">
                <button onClick={handleThemeMode} id="theme_icon">
                  {value === "dark" ? <FiSun /> : <MdDarkMode />}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {menuShow && (
        <div
          className="backdrop_effect header_backdrop"
          onClick={() => setMenuShow(false)}
        ></div>
      )}
    </header>
  );
};

export default Header;
